import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './language-selector-header.module.css';
import { AdminService } from '../../../services/admin';
import { portalLanguages } from '../../../translation/languages';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAdminError, setAdminData } from '../../../reducers/adminReducer';
import { RootState } from '../../../store/store';

export const LanguageSelectorHeader: React.FC = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const { admin } = useSelector((state: RootState) => state.admin);

  useEffect(() => {
    if (admin) {
      if (admin.language === 'kk') {
        admin.language = 'ru';
      }
      i18n.changeLanguage(admin.language);
      localStorage.setItem('language', admin.language);
    }
  }, [admin]);

  const handleLanguageChange = async (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
    const { data, error } = await AdminService.setLanguage(lang);
    if (data) {
      dispatch(setAdminData(data));
    } else if (error) {
      dispatch(fetchAdminError(error.message));
    }
  };

  return (
    <div className={styles.languageSelector}>
      {portalLanguages.map((lang) => (
        <button
          key={lang.code}
          className={`${styles.languageButton} ${i18n.language === lang.code ? styles.active : ''}`}
          onClick={() => handleLanguageChange(lang.code)}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};
